// tslint:disable-next-line:no-any
const defaultShim: () => any = () => {
  throw new Error('Uninitialized EventUtils module use.');
};

class BootstrapUtility {
  private static isEmbedded: () => boolean = defaultShim;

  public static get IsEmbedded(): () => boolean {
    return BootstrapUtility.isEmbedded;
  }

  public static set IsEmbedded(v: () => boolean) {
    BootstrapUtility.isEmbedded = v;
  }
}

class TsConfig {
  private static isMobile: () => boolean = defaultShim;

  public static get IsMobile(): () => boolean {
    return TsConfig.isMobile;
  }

  public static set IsMobile(v: () => boolean) {
    TsConfig.isMobile = v;
  }
}

class FeatureParam {
  private static debugTools: () => boolean = defaultShim;

  public static get DebugTools(): () => boolean {
    return FeatureParam.debugTools;
  }

  public static set DebugTools(v: () => boolean) {
    FeatureParam.debugTools = v;
  }
}

class FeatureFlag {
  private static isEventHandlingReworkEnabled: () => boolean = defaultShim;

  public static get IsEventHandlingReworkEnabled(): () => boolean {
    return FeatureFlag.isEventHandlingReworkEnabled;
  }

  public static set IsEventHandlingReworkEnabled(v: () => boolean) {
    FeatureFlag.isEventHandlingReworkEnabled = v;
  }
}

class Logger {
  private static debug: (_: string) => void = (unused: string) => {
    // by default ignore
  }

  public static get Debug(): (_: string) => void {
    return Logger.debug;
  }

  public static set Debug(v: (_: string) => void) {
    Logger.debug = v;
  }
}

export { BootstrapUtility, TsConfig, FeatureParam, FeatureFlag, Logger };
